import 'react-tabs/style/react-tabs.css';
import CodeTabs from "../../../../src/components/CodeTabs";
import pdf from "../../../../src/blog/second-post/c64manual.pdf";
import * as React from 'react';
export default {
  CodeTabs,
  pdf,
  React
};